import constants from '../../../../../../appConstants';
import { formatDateTime } from '@dataGrid/gridUtilities';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ name }) {
    return GridConfig.getDefaultConfiguration({ name });
  }

  static getCustomerAddress(params) {
    return [params.data.address, params.data.address2].filter(Boolean).join(', ');
  }

  static getDefaultConfiguration({ name }) {
    return {
      title: name,
      keyColumn: 'code',
      rowSelection: 'multiple',
      rowDeselection: 'true',
      columns: [
        {
          headerName: 'Acc #',
          headerTooltip: 'Customer Account Number',
          field: 'code',
          minWidth: constants.columnWidth.CUSTOMER_CODE,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'code',
          lockPosition: true
        },
        {
          headerName: 'Shipper Name',
          headerTooltip: 'Shipper Name',
          field: 'name',
          minWidth: constants.columnWidth.CUSTOMER,
          lockPosition: true,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'name',
          filterParams: {
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: 'Address',
          headerTooltip: 'Customer Address',
          minWidth: constants.columnWidth.CUSTOMER_ADDRESS,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: GridConfig.getCustomerAddress,
          tooltipValueGetter: (params) => params.value,
          filterParams: {
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: 'City',
          headerTooltip: 'City',
          field: 'city',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.CITY,
          filter: MultiSelectFilter,
          tooltipField: 'city'
        },
        {
          headerName: 'State',
          headerTooltip: 'State',
          field: 'state',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.STATE,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Zip',
          headerTooltip: 'Zip',
          field: 'zip',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.ZIP_CODE,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Terminal',
          headerTooltip: 'Terminal',
          field: 'terminalCode',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          minWidth: constants.columnWidth.W_100
        },
        {
          headerName: 'Last Updated (UTC)',
          headerTooltip: 'Last Updated (UTC)',
          field: 'lastUpdated',
          minWidth: constants.columnWidth.IBETA,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          valueFormatter: formatDateTime,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME
          }
        }
      ]
    };
  }
}

export default GridConfig;
